import { vendors } from '../../../../config/environment';

var unprefixPattern = new RegExp( '^-(?:' + vendors.join( '|' ) + ')-' );

export default function ( prop ) {
	return prop.replace( unprefixPattern, '' );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/element/transitions/unprefix.js.map
